<template>
<div class="popupWrap">
  <div class="popup_inner">
    <span><a href="javascript:" @click="colseModal()"><img src="/static/images/main/close_menu.png" alt=""></a></span>
    <h2>회사명 검색</h2>

    <div class="pop_choice">
      <label class="radioArea"><input type="radio" name="viewOpt" value="Y" onclick="" checked="" v-model="viewOpt"><span class="fakeRadiobox"></span> 기업협의회 임직원</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <label class="radioArea"><input type="radio" name="viewOpt" value="O" onclick="" v-model="viewOpt"><span class="fakeRadiobox"></span> 일반회사 임직원</label>
    </div>

    <!-- 검색 기업협의회 임직원 일때 -->
    <div class="pop_search" v-if="viewOpt=='Y'">
      <div class="inputBox">
        <input type="text" class="input_ty1" name="search_keyword" autocomplete="off" value="" v-model="search">
        <input type="button" class="btn_search" value="" onclick="">
      </div>
      <!--select name="search_field" id="" class="select_ty1">
        <option value="ALL">전체</option>
        <option value="SUBJECT">회사명</option>
      </select-->
    </div>

    <!-- 검색 일반회사 임직원 일때 -->
    <div class="pop_search"  v-if="viewOpt=='O'">
      <!-- div class="inputBox">
        <input type="text" class="input_ty1" name="search_keyword" value="" placeholder="기업명">
        <input type="button" class="btn_search" value="">
      </div-->
      <div class="inputBox">
        <input type="text" name="search_keyword" value="" autocomplete="off" placeholder="기업명을 입력하세요" class="input_ty1" v-model="searchKeywordOthersName" >
        <input type="text" name="search_keywordorgNo" value="" autocomplete="off" placeholder="사업자등록번호앞6자리('-'없이 숫자만)" class="input_ty1"  v-model="searchKeywordOthersOrgNo">
        <button class="BtnCompanySearch"  @click="getOrgApiNewList()">검색</button>
      </div>
    </div>
    <!-- 리스트 기업협의회 임직원 일때 -->
    <div class="pop_result" v-if="viewOpt=='Y'">
      <table>
        <colgroup>
          <col width="10%">
          <col width="30%">
          <col width="20%">
          <col width="*">
        </colgroup>
        <thead>
          <tr>
            <th>선택</th>
            <th>회사명</th>
            <th>대표자명</th>
            <th>주소</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="org in paginatedData" v-bind:key="org.keyid">
            <td>
                <label class="check">
                <input type="checkbox" @click="confirmCompany(org.keyid, org.orgNameKor, org.orgNo)"><span class="checkmark"></span>
                </label>
            </td>
            <td v-text="org.orgNameKor"></td>
            <td v-text="org.orgCeoName"></td>
            <td >{{ org.orgAddr1}} {{ org.orgAddr2 }}</td>
          </tr>
          <tr v-if="paginatedData.length===0">
            <td colspan="4">
              검색 결과가 없습니다.
            </td>
          </tr>
        </tbody>
      </table>
      <div class="paging" v-if="paginatedData.length > 0">
        <ol>
          <template v-if="pageNum!=0">
            <li class="first" @click="prevPage">〈</li>
          </template>
          <template v-else>
            <li class="first">〈</li>
          </template>
          <template v-for="no in pageCount" v-if="Math.abs(no - pageNum-1) < 3 || (pageNum <= 2 && no<=5) || (pageNum >= pageCount-2 && no > pageCount-5)">
            <li v-bind:key="no" v-text="no" @click="goPage(no)" :class="{'active': isCur(no)}"></li>
          </template>
          <template v-if="pageNum!=pageCount-1">
            <li class="last" @click="nextPage">〉</li>
          </template>
          <template v-else>
            <li class="last">〉</li>
          </template>
        </ol>
      </div>
    </div>

    <!-- 리스트 일반회사 임직원 일때 -->
    <div class="pop_result"  v-if="viewOpt=='O'">
      <table>
        <colgroup>
          <col width="10%">
          <col width="30%">
          <col width="*">
        </colgroup>
        <thead>
          <tr>
            <th>선택</th>
            <th>회사명</th>
            <th>주소</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="org in paginatedEtcData" v-bind:key="org.orgNameKor">
            <td>
                <label class="check">
                <input type="checkbox" @click="confirmCompany('', org.orgNameKor, org.orgNo)"><span class="checkmark"></span>
                </label>
            </td>
            <td v-text="org.orgNameKor"></td>
            <td v-text="org.orgAddr1"></td>
          </tr>
          <tr v-if="paginatedEtcData.length===0">
            <td colspan="3">
              검색 결과가 없습니다.
            </td>
          </tr>
        </tbody>
      </table>

      <div class="paging" v-if="paginatedEtcData.length > 0">
        <ol>
          <template v-if="pageEtcNum!=0">
            <li class="first" @click="prevEtcPage">〈</li>
          </template>
          <template v-else>
            <li class="first">〈</li>
          </template>
          <template v-for="no in pageEtcCount">
            <li v-bind:key="no" v-text="no" @click="goEtcPage(no)" :class="{'active': isEtcCur(no)}"></li>
          </template>
          <template v-if="pageEtcNum!=pageEtcCount-1">
            <li class="last" @click="nextEtcPage">〉</li>
          </template>
          <template v-else>
            <li class="last">〉</li>
          </template>
        </ol>
        <!--ol>
          <li @click="searchApiNext()" v-if="paginatedEtcData.length > 1">계속검색</li>
        </ol-->
      </div>
    </div>

  </div>
  <loading :active.sync="isLoading"
       :can-cancel="false"
       :is-full-page="fullPage"></loading>
</div>
</template>
<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data: function () {
    return {
      search: '',
      orgList: [],
      viewOpt: 'Y',
      pageNum: 0,
      pageSize: 5,
      searchKeywordOthersName: '',
      searchKeywordOthersOrgNo: '',
      pageNo: 1,
      apiOrgList: [],
      isLoading: false,
      fullPage: false,
      pageEtcNum: 0,
      pagenationPer: 5
    }
  },
  props: [
    'hot_table'
  ],
  components: {
    Loading
  },
  methods: {
    colseModal () {
      this.$emit('close')
    },
    getOrgList: function () {
      var _this = this
      // 기업목록조회
      const url = '/web/api/org'
      _this.isLoading = true
      axios.get(url, {withCredentials: true})
        .then(function (response) {
          if (response.status === 200) {
            _this.orgList = response.data
            _this.search = ''
            _this.isLoading = false
          } else {
            alert('목록 조회에 실패하였습니다. 잠시 후 다시 이용 부탁드립니다.')
            _this.isLoading = false
          }
        })
        .catch(function () {
          alert('오류가 발생하였습니다. 관리자에게 문의하여 주십시오')
          _this.isLoading = false
        })
    },
    getOrgApiList: function () {
      var _this = this
      if (_this.searchKeywordOthersName === '' || _this.searchKeywordOthersOrgNo === '') {
        alert('기업명과 사업자등록번호앞 6자리를 입력하세요')
        return
      }
      if (_this.searchKeywordOthersOrgNo.length !== 6) {
        alert('사업자등로번호앞 6자리를 입력하세요')
        return
      }
      // 비회원 기업목록조회
      _this.isLoading = true
      const url = '/web/api/org/others'
      axios.get(url, {withCredentials: true, params: { searchKeyword: _this.searchKeywordOthersName, searchOrgNo: _this.searchKeywordOthersOrgNo, pageNo: _this.pageNo }})
        .then(function (response) {
          if (response.status === 200) {
            _this.apiOrgList = response.data
            _this.pageEtcNum = 0
            _this.isLoading = false
          } else {
            alert('목록 조회에 실패하였습니다. 잠시 후 다시 이용 부탁드립니다.')
            _this.isLoading = false
          }
        })
        .catch(function () {
          alert('오류가 발생하였습니다. 관리자에게 문의하여 주십시오')
          _this.isLoading = false
        })
    },
    getOrgApiNewList: function () {
      var _this = this
      _this.pageNo = 1
      _this.getOrgApiList()
    },
    searchApiNext: function () {
      var _this = this
      _this.pageNo++
      _this.getOrgApiList()
    },
    confirmCompany (id, val, no) {
      if (no != null) {
        no = no.replace(/-/gi, '').substr(0, 6)
      }
      var data = {
        'orgId': id, 'orgName': val, 'orgNo': no
      }
      this.$emit('childs-event', data)
      this.$emit('close')
    },
    nextPage () {
      this.pageNum += 1
    },
    prevPage () {
      this.pageNum -= 1
    },
    goPage (no) {
      this.pageNum = no - 1
    },
    isCur (no) {
      return this.pageNum === no - 1
    },
    nextEtcPage () {
      this.pageEtcNum += 1
    },
    prevEtcPage () {
      this.pageEtcNum -= 1
    },
    goEtcPage (no) {
      this.pageEtcNum = no - 1
    },
    isEtcCur (no) {
      return this.pageEtcNum === no - 1
    },
    pageShow (no) {
      let _this = this
      let listLeng = _this.filteredOrgs.length
      let listSize = _this.pageSize
      let page = Math.floor(listLeng / listSize)
      if (page < 6) {
        return true
      }
      let startPageNum = _this.no - Math.floor(_this.pagenationPer / 2)
      let endPageNum = _this.no + Math.floor(_this.pagenationPer / 2)
      if (startPageNum < 1) {
        endPageNum = endPageNum - startPageNum
        startPageNum = 1
      }
      if (endPageNum > page) {
        startPageNum = page - _this.pagenationPer
        endPageNum = page
      }
      if (no >= startPageNum && no <= endPageNum) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getOrgList()
  },
  computed: {
    filteredOrgs () {
      let _this = this
      if (!_this.search || _this.search.length === 0) return _this.orgList

      var find = function (object, search) {
        if (object.orgNameKor.includes(search)) return true
        else return false
      }

      return _this.orgList.filter(org => {
        return find(org, _this.search)
      })
    },
    pageCount () {
      let _this = this
      let listLeng = _this.filteredOrgs.length
      let listSize = _this.pageSize
      let page = Math.floor(listLeng / listSize)
      if (_this.pageNum > page) _this.pageNum = page
      if (listLeng % listSize > 0) page += 1
      return page
    },
    paginatedData () {
      let _this = this
      const start = _this.pageNum * _this.pageSize
      const end = start + _this.pageSize
      return _this.filteredOrgs.slice(start, end)
    },
    pageEtcCount () {
      let _this = this
      let listLeng = _this.apiOrgList.length
      let listSize = _this.pageSize
      let page = Math.floor(listLeng / listSize)
      if (_this.pageNum > page) _this.pageNum = page
      if (listLeng % listSize > 0) page += 1
      return page
    },
    paginatedEtcData () {
      let _this = this
      const start = _this.pageEtcNum * _this.pageSize
      const end = start + _this.pageSize
      return _this.apiOrgList.slice(start, end)
    }
  }
}
</script>

<style scoped>
th, td {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/CompanySearch.vue